import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { SessionManager } from '../../../session/service/session-manager';
import { GlobalEventBus } from '../../event/global-bus';
import { TimezoneStorage } from './timezone-storage';

@Injectable({
  providedIn: 'root'
})
export class FormatDateService {

  timezone: string;

  constructor(private sessionManager: SessionManager,
              private globalEventBus: GlobalEventBus) {
    this.init();
  }

  init() {
    this.globalEventBus.bind('user:updated', () => {
      this.timezone = TimezoneStorage.get();
    });
    this.timezone = TimezoneStorage.get();
  }

  public format(date: any, format: string = 'YYYY-MM-DD HH:mm:ss', timezone?: string): string {
    if (!format) {
      format = 'YYYY-MM-DD HH:mm:ss';
    }
    if (!timezone) {
      timezone = this.timezone || moment.tz.guess();
    }

    return moment.tz(date, 'UTC').tz(timezone).format(format);
  }

  public convertToUTC(date, timezone?: string): moment {
    if (!timezone) {
      timezone = this.timezone;
    }
    return moment.tz(date, timezone).tz('UTC');
  }
}
